export default __webpack_public_path__ + "static/media/logo-black.11fd89d7.svg";